import React from "react";
import { NavLink } from 'react-router-dom'
import { CCard, CCardHeader, CCardBody } from '@coreui/react'
import SyntaxHighlighter from 'react-syntax-highlighter';
import { docco } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { codeSnippet } from '../../utils/codeSnippet/angular/AngularNewFeatures';

function AngularNewFeatures () {
  return (
    <CCard className="mb-4">
      <CCardHeader>
        <div className="d-flex justify-content-between align-items-center">
          <div className="header-links">
            <a href="#angular-versions" className="me-2">Angular Versions</a>
            <a href="#standalone-components" className="me-2">Standalone Components</a>
            <a href="#angular-structure" className="me-2">Angular Structure</a>
            <a href="#zoneless-angular" className="me-2">Zoneless</a>
            <a href="#inject" className="me-2">Inject</a>
            <a href="#application-config" className="me-2">ApplicationConfig</a>
            <a href="#provider" className="me-2">Provider</a>
            <a href="#inject-decorator">@Inject</a>
          </div>
        </div>
      </CCardHeader>
      <CCardBody>   
        <p id="angular-versions"><b>Angular Versions</b></p>       
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code1}</SyntaxHighlighter>
        <p>Commands for creating angular projects:</p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code4}</SyntaxHighlighter>        
        
        <p id="standalone-components"><b>Standalone Components</b></p>      
        <p>standalone project (or standalone components) means you can build your app without using NgModules.</p>
        <p>Earlier, every app required NgModules:</p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code2}</SyntaxHighlighter>
        <p>With Angular 14+ (stable in 15), you can create components like this:</p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code3}</SyntaxHighlighter>
        
        <p>A standalone project is an Angular app where:</p>
        <ul>
          <li>No AppModule</li>
          <li>Components, directives, pipes are self-contained</li>
          <li>Dependencies are declared directly inside components</li>
          <li>Bootstrapping is done using bootstrapApplication()</li>
        </ul>
        
        <p id="zoneless-angular"><b>What is "Zoneless" Angular? ------  Need to Learn more</b></p>
        <p>Zoneless Angular refers to the removal of the Zone.js dependency, which was used for change detection in earlier versions of Angular. This change leads to improved performance and reduced bundle size.</p>

        <p id="angular-structure"><b>Angular Structure</b></p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code5}</SyntaxHighlighter>
        <p>main.ts (Entry Point)</p>  
        <p>app.component.ts (Root Component)</p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code7}</SyntaxHighlighter>
        <p>Routing (app.routes.ts)</p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code8}</SyntaxHighlighter>
        
        <p id="inject"><b>Inject</b></p>
        <p>Constructor Injection (Traditional)</p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code9}</SyntaxHighlighter>
        <p> inject() Function</p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code10}</SyntaxHighlighter>
        <p id="application-config"><b>ApplicationConfig - angular 14+</b></p>
        <p>ApplicationConfig is an interface used to configure and bootstrap a standalone Angular app (without NgModule).</p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code11}</SyntaxHighlighter>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code12}</SyntaxHighlighter>

        <p id="provider"><b>Provider in Angular</b></p>
        <p>A provider tells Angular's Dependency Injection (DI) system how to create or supply a service/value.</p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code13}</SyntaxHighlighter>

        <p>1. Tokens (tokens.ts)</p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code14}</SyntaxHighlighter>
        <p>2. Services (logger.service.ts)</p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code15}</SyntaxHighlighter>
         <p>better-logger.service.ts</p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code16}</SyntaxHighlighter>
        <p>App Config (All Provider Types)</p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code17}</SyntaxHighlighter>
        <p>Bootstrap (main.ts)</p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code18}</SyntaxHighlighter>
        <p>Component Usage (app.component.ts)</p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code19}</SyntaxHighlighter>

        <p id="inject-decorator"><b>@Inject (Decorator)</b></p>
        <p>Used inside constructor injection</p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code20}</SyntaxHighlighter>

        <p id="iSignals"><b>Signals (Angular 16)</b></p>
        <p>Signals are a new way to manage state in Angular applications, providing a more efficient and intuitive approach to handling reactive data.</p>
        <p>They replace or reduce the need for: RxJS (in some cases), Manual change detection, Complex state management</p>
        <p>A signal = a reactive variable -> It stores a value, Angular tracks when it changes, UI updates automatically</p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code21}</SyntaxHighlighter>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code22}</SyntaxHighlighter>

        <p><b>Control Flow</b></p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code23}</SyntaxHighlighter>

        <p><b>Required Inputs</b></p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code24}</SyntaxHighlighter>

        <p><b>Property Binding</b></p>
        <p>Property binding is one-way, from component → view. </p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code25}</SyntaxHighlighter>

        <p><b>Guards (Angular 14+)</b></p>
        <p>Angular 19 supports both Class-based Guards (legacy) and Functional Guards (recommended). Functional guards are the modern approach and provide better tree-shaking and simpler implementation. Commonly used with standalone Angular apps</p>
        <p>Old way (class-based) 👇 (Requires class + constructor)</p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code26}</SyntaxHighlighter>
        <p>Functional Guard (Modern Way)</p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code27}</SyntaxHighlighter>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code28}</SyntaxHighlighter>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code29}</SyntaxHighlighter>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code30}</SyntaxHighlighter>
        <p>Types of Functional Guards</p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code31}</SyntaxHighlighter>

        <p><b>Interceptors</b></p>
        <p>Interceptors let you intercept and modify HTTP requests and responses globally.</p>
        <p>Works with Angular’s HttpClient. 👉 Used for auth, logging, error handling, headers, etc.</p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code32}</SyntaxHighlighter>

        <p><b>New modern lifecycle APIs</b></p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code33}</SyntaxHighlighter>
        <p>🔥 1. afterNextRender</p>
        <p>Runs only once, after the next DOM update</p>
        <p><b>Use Cases</b></p>
        <ul>
          <li><p>Access DOM safely after render</p></li>
          <li><p>Initialize third-party libraries</p></li>
          <li><p>Focus input field</p></li>
        </ul>          
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code34}</SyntaxHighlighter>
        <p>🔥 2. afterRender</p>
        <p>Runs every time Angular re-renders</p>
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code35}</SyntaxHighlighter>
        <p><b>Use Cases</b></p>
        <ul>
          <li><p>Track UI updates</p></li>
          <li><p>Recalculate layout</p></li>
          <li><p>Logging render cycles</p></li>
        </ul>   
        <SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code36}</SyntaxHighlighter>

      </CCardBody>
    </CCard>        
  )
}

export default AngularNewFeatures;